import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import Swal from "sweetalert2";



//this is the components of the Add Payment
export const AddPayment = ({ isOpen, onClose, selectItem, pandingPayment, fetchQuantity, selectedYear, selectedMonth }) => {

    // Destructure properties from selectedItem
    const { itemName, itemID } = selectItem || {};
    const [formData, setFormData] = useState({
        date: new Date(), // Initialize date with current date
        payAmount: '',
    });

    const [currency, setCurrency] = useState("");
    const [SelectDate, setSelectedDate] = useState(new Date());
    const currentDate = new Date();

    //get userid form loca storage
    const storedUserData = localStorage.getItem('userData');
    let userId = '';
    let groupId = '';
    if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        userId = userData.userId;
        groupId = userData.groupId;
    }



    useEffect(() => {
        const fetchCurrencyData = async () => {
            try {

                const response = await fetch(`${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`);
                const data = await response.json();
                // Assuming the API response has a property called 'currency'
                setCurrency(data.currency);

            } catch (error) {
                console.error("Error fetching currency data:", error);
            } finally {

            }
        };

        fetchCurrencyData();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the payment?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel'
            });

            if (result.isConfirmed) {

                const formattedDate = SelectDate.toISOString().split('T')[0]; // Extract date portion and remove time
                const formattedAmount = parseInt(pandingPayment); // Convert to integer
                const formattedData = {
                    itemID: itemID,
                    paymentDate: formattedDate,
                    paymentAmount: formattedAmount.toString() // Convert to string
                };

                const response = await fetch(`${BASE_URL}/api/PaymentsTracking/InsertPayment`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formattedData), // Send formatted data
                });
                if (response.ok) {
                    await Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Payment successfully.',
                    });

                    fetchQuantity(itemID, selectedYear, selectedMonth);
                    onClose(); // Close the modal
                    setFormData({
                        payAmount: ''
                    })
                } else {
                    console.error('Error inserting payment:', response.statusText);
                }
            }
        } catch (error) {
            console.error('Error inserting payment:', error);
        }
    };

    return (
        <>
            {isOpen && (
                <div className="fixed top-0  p-4  left-0 w-full h-full flex justify-center items-center z-50">
                    <div className="bg-white rounded-lg p-4 z-50">
                        <div className="container mx-auto px-4 h-full">
                            <div className="flex content-center items-center justify-center h-full">
                                <div className="w-full lg:w-12/12">
                                    <div className="relative flex flex-col min-w-0 break-words w-full ">
                                        <div className="rounded-t mb-0 px-3 py-3">
                                            <div className="mb-1">
                                                <h6 className="text-blueGray-800 text-sm text-2xl font-bold">
                                                    Pay Pending  Amount({currency}) for {itemName}
                                                </h6>
                                            </div>
                                            <hr className="mt-6 border-b-1 border-blueGray-300" />
                                        </div>
                                        <div className="flex-auto px-4 lg:px-6 pt-0">
                                            <form onSubmit={handleSubmit} >
                                                <div className="mb-4 md:flex md:w-full">
                                                    {/* First Column */}
                                                    <div className="md:w-1/2 pr-4">
                                                        {/* Total Price */}
                                                        <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="dateRange">
                                                            Total Price to Pay: {pandingPayment}
                                                        </label>

                                                    </div>
                                                </div>
                                                {/* Second Column */}
                                                <div className="mb-4 md:flex md:w-full">

                                                    {/* Input Box for Date */}
                                                    <div className="mb-4  ">
                                                        <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="date">
                                                            Select Date
                                                        </label>
                                                        <DatePicker
                                                            selected={SelectDate}
                                                            onChange={date => setSelectedDate(date)}
                                                            className="border"
                                                            // className={`border-0 px-3 form-control datepicker mb-1 w-full py-3 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150 `}
                                                            dateFormat="dd/MM/yyyy"
                                                            maxDate={currentDate}
                                                        />
                                                    </div>
                                                    {/* Input Box for Amount */}
                                                    <div className="mb-4 ml-3 ">
                                                        <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="payAmount">
                                                            Amount
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="payAmount"
                                                            name="payAmount"
                                                            maxLength={30}
                                                            value={pandingPayment} // Set value to pendingPayment
                                                            className="border"
                                                            // className={`border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 `}
                                                            placeholder="Pay Amount"
                                                            disabled // Add disabled attribute to disable input
                                                        />

                                                    </div>
                                                </div>

                                                <div className="text-right mt-4 flex flex-row justify-end">
                                                    <button className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" onClick={onClose}>
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150"
                                                    >
                                                        Pay
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};




